// src/pages/Sensor/DataGenerator.tsx

import { CalendarTodayTwoTone, MemoryTwoTone } from '@mui/icons-material'
import { Avatar, Button, Card, CardContent, Divider } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { AM, HStack, KPage, KTextField, Preloader } from '../../components'
import { OperatorData, useMissingData, useOperator } from '../../hooks'

const randomnum = (minValue, maxValue) => {
  const min = Number(minValue)
  const max = Number(maxValue)

  return (Math.random() * (max - min) + min).toFixed(2)
}

export const DataGenerator = () => {
  //const navigate = useNavigate()
  const { id } = useParams()

  const [startDay, setStartDay] = useState('')
  const [endDay, setEndDay] = useState('')
  const [month, setMonth] = useState('')
  const [year, setYear] = useState('')
  const [sensorID, setSensorID] = useState('')
  const [minValue, setMinValue] = useState('')
  const [maxValue, setMaxValue] = useState('')
  const [queries, setQueries] = useState([])
  //const [totalSum, setTotalSum] = useState(0)
  const [sensorIDCopyOld, setSensorIDCopyOld] = useState(0)
  const [sensorIDCopyNew, setSensorIDCopyNew] = useState(0)
  const [monthQuerie, setMonthQuerie] = useState('')

  const [missingLoading, setMissingLoading] = useState(true)

  const navigate = useNavigate()

  const opData: OperatorData = useOperator()

  useEffect(() => {
    if (!opData?.isAdmin) navigate('/')
  }, [navigate, opData])

  const { data: missingData, isLoading } = useMissingData(id)
  useEffect(() => {
    setMissingLoading(isLoading)
  }, [isLoading])

  const [actionMenu, setActionMenu] = useState(null)

  const createSQL = (
    startDay,
    endDay,
    month,
    year,
    sensorID,
    minValue,
    maxValue
  ) => {
    const sqlStart = `INSERT INTO history_aggregated (sensor_id, value, hours, days, months, years) VALUES `
    const sqlValuesBeforeNumber = `(${sensorID}, `
    const sqlValuesAfterNumber = `, ${month}, ${year});`
    const totalSum = 0
    const queries = []

    while (startDay <= endDay) {
      const randomValue = randomnum(minValue, maxValue)

      queries.push(
        sqlStart +
          sqlValuesBeforeNumber +
          randomValue +
          ', NULL, ' +
          startDay +
          sqlValuesAfterNumber
      )
      //setTotalSum(Number(totalSum) + Number(randomValue))
      setStartDay(startDay + 1)
    }

    //setTotalSum(totalSum)
    setMonthQuerie(
      sqlStart +
        sqlValuesBeforeNumber +
        totalSum +
        ', NULL, Null' +
        sqlValuesAfterNumber
    )

    return queries
  }

  const generateQueries = () =>
    setQueries(
      createSQL(startDay, endDay, month, year, sensorID, minValue, maxValue)
    )

  const dateArray = []
  const sqlStart =
    'INSERT INTO history_aggregated (sensor_id, value, hours, days, months, years) VALUES '

  if (sensorIDCopyNew !== 0) {
    missingData.item.forEach(dates => {
      dateArray.push(
        sqlStart +
          '(' +
          sensorIDCopyNew +
          ',' +
          dates.value +
          ',' +
          dates.hours +
          ',' +
          dates.days +
          ',' +
          dates.months +
          ',' +
          dates.years +
          ');'
      )
    })
  }

  return (
    <>
      {/* preloader */}
      <Preloader isLoading={missingLoading} />
      {/* preloader end */}

      {/* action menu */}
      <AM
        anchorEl={actionMenu}
        caption={'Sensoren'}
        onClose={() => setActionMenu(null)}
        open={Boolean(actionMenu)}
      >
        <Divider />
      </AM>
      {/* action menu end */}

      {missingLoading && (
        <KPage
          avatar={
            <Avatar>
              <MemoryTwoTone />
            </Avatar>
          }
          title={'Sensordaten Generator'}
        >
          <Card>
            <CardContent>
              <HStack sx={{ width: 1 }}>
                <KTextField
                  icon={<CalendarTodayTwoTone />}
                  label={'Start Tag'}
                  onChange={event => setStartDay(event.target.value)}
                  value={startDay}
                />

                <KTextField
                  icon={<CalendarTodayTwoTone />}
                  label={'End Tag'}
                  onChange={event => setEndDay(event.target.value)}
                  value={endDay}
                />

                <KTextField
                  icon={<CalendarTodayTwoTone />}
                  label={'Monat'}
                  onChange={event => setMonth(event.target.value)}
                  value={month}
                />

                <KTextField
                  icon={<CalendarTodayTwoTone />}
                  label={'Jahr'}
                  onChange={event => setYear(event.target.value)}
                  value={year}
                />
              </HStack>

              <HStack sx={{ width: 1 }}>
                <KTextField
                  icon={<MemoryTwoTone />}
                  label={'Sensor ID'}
                  onChange={event => setSensorID(event.target.value)}
                  value={sensorID}
                />

                <KTextField
                  label={'Minimaler Wert'}
                  onChange={event => setMinValue(event.target.value)}
                  value={minValue}
                />

                <KTextField
                  label={'Maximaler Wert'}
                  onChange={event => setMaxValue(event.target.value)}
                  value={maxValue}
                />
              </HStack>

              <HStack>
                <Button onClick={() => generateQueries()}>
                  Queries erzeugen
                </Button>
              </HStack>

              <HStack>
                <h3>Queris der fehlenden Tage</h3>
                {queries.map(query => query)}
              </HStack>

              <HStack>
                <h3>Queris des fehlenden Monats</h3>
                {monthQuerie}
              </HStack>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <HStack sx={{ width: 1 }}>
                <KTextField
                  label={'Alte Sensor ID'}
                  onChange={event =>
                    setSensorIDCopyOld(Number(event.target.value))
                  }
                  value={sensorIDCopyOld}
                />

                <KTextField
                  label={'Neue Sensor ID'}
                  onChange={event =>
                    setSensorIDCopyNew(Number(event.target.value))
                  }
                  value={sensorIDCopyNew}
                />
              </HStack>

              <HStack sx={{ width: 1 }}>{dateArray.map(query => query)}</HStack>
            </CardContent>
          </Card>
        </KPage>
      )}
    </>
  )
}
